/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Not_EditableInputs */

const en_error_linesheet_not_editable = /** @type {(inputs: Error_Linesheet_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow is working on this linesheet: you can change it again when it comes back to you.`)
};

/**
* | output |
* | --- |
* | "Tomorrow is working on this linesheet: you can change it again when it comes back to you." |
*
* @param {Error_Linesheet_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_not_editable = /** @type {((inputs?: Error_Linesheet_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_not_editable(inputs)
});